import { useCallback } from "react";

export const useDiscountCalculator = () => {
    const calculatePrice = useCallback((mrp: number, discountPercentage: number): number => {
        if (!mrp || mrp <= 0) return 0;
        if (!discountPercentage || discountPercentage <= 0) return mrp;
        if (discountPercentage >= 100) return 0;

        return mrp - (mrp * (discountPercentage / 100));
    }, []);

    const calculateUnitPrice = useCallback((mrp: number): number => {
        if (!mrp || mrp <= 0) return 0;
        return Number(((mrp * 100) / 118).toFixed(2));
    }, [])

    return { calculatePrice, calculateUnitPrice };
};
